module.exports = __webpack_public_path__ + "img/riseup-pool-header.fdbae55e.svg";